import Plug from './Plug'

export default Plug